import { render, staticRenderFns } from "./CurrScore.vue?vue&type=template&id=730101b5"
import script from "./CurrScore.vue?vue&type=script&lang=js"
export * from "./CurrScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports